if (!customElements.get('ths-complementary-add')) {
customElements.define('ths-complementary-add', class extends HTMLElement {
connectedCallback() {
this.root = this.closest('product-info');
this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
this.button = this.querySelector('button[type="submit"]');
this.input = this.querySelector('input[name="id"]');
this.onChange = event => {
if (event.target.closest('variant-selects') && this.root.contains(event.target)) {
this.button.disabled = true; this.input.value = '';
}};
this.root.addEventListener('change', this.onChange);
this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
if (data.sectionId === this.root.dataset.section) this.sync(data.variant);
});
const selected = this.root.querySelector('variant-selects [data-selected-variant]');
this.sync(selected ? JSON.parse(selected.textContent) : null);
}
disconnectedCallback() {
this.root?.removeEventListener('change', this.onChange);
this.unsubscribe?.();
}
language(title) {
const text = String(title || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
const codes = {
it: /\b(it|ita|italiano|italian|italien|italienisch)\b/,
en: /\b(en|eng|inglese|english|anglais|englisch|ingles)\b/,
de: /\b(de|deu|tedesco|deutsch|german|allemand|aleman)\b/,
fr: /\b(fr|fra|francese|francais|french|franzosisch|frances)\b/,
es: /\b(es|esp|spagnolo|espanol|spanish|espagnol|spanisch)\b/
};
return Object.keys(codes).find(code => codes[code].test(text));
}
sync(main) {
const code = this.language(main?.title) || this.closest('product-recommendations').dataset.defaultLanguage;
const matches = this.variants.filter(v => code && this.language(v.title) === code);
const variant = matches.length === 1 ? matches[0] : null;
const names = {it:'Italiano',en:'English',de:'Deutsch',fr:'Français',es:'Español'};
this.input.value = variant?.available ? variant.id : '';
this.button.disabled = !variant?.available;
this.querySelector('[data-language]').textContent = variant?.available ? this.dataset.pdf + ' · ' + names[code] : this.dataset.unavailable;
this.querySelector('[data-price]').textContent = variant?.price || '';
this.querySelector('[data-compare]').textContent = variant?.compare || '';
this.querySelector('product-form')?.handleErrorMessage();
}
});
}